import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams, useRoutes } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import { FaMinus, FaPlus } from 'react-icons/fa'
import UserImage from "../../../assets/user.png"

const ManageAdmins = () => {
    const [storeAdmins, setStoreAdmins] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [loadingRemove, setLoadingRemove] = useState(false)

    const { name } = useParams()

    const navigate = useNavigate()

    useEffect(() => {
        const getAdmins = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/admins`)
                setIsLoading(false)
                if (response) {
                    setStoreAdmins(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getAdmins()
    }, [])

    const handleRemove = async (id) => {
        try {
            setLoadingRemove(true)
            await api.patch(`/stores/${name}/manage/admins`, { id })
            setLoadingRemove(false)
            toast.success("admin removed")

        } catch (error) {
            toast.error("Error,admin not removed")
        }
    }
    return (
        <div className="shop-admins">
            <div className="admins-page-header">
                <h2 className="store-name">{name}</h2>
                <p className='page-title'>Admins</p>
                <button 
                onClick={()=>navigate(`/b/manage/${name}/admins/new`)}
                className='new-admins-btn'
                >Add New</button>
            </div>
            <div className="admins-list">
                {
                    storeAdmins?.length >= 0 && storeAdmins.map((admin) => (
                        <div className="admin-card-container">
                            <Link to={`/user/${admin._id}`}>
                                <div className="admin-card-details">
                                    <div className="admin-card-profile-image">
                                        <img src={admin?.profilePic ? admin.profilePic.url : UserImage} alt='' />
                                    </div>
                                    <div className="user-profile-name">
                                        <p className='user-card-name'>{admin?.firstname} {admin?.lastname}</p>
                                    </div>
                                </div>
                            </Link>
                            <div className="admin-chat-btn" onClick={() => handleRemove(admin._id)}>
                                <FaMinus /> <p>Remove</p>
                            </div>
                        </div >
                    ))
                }
            </div>
            {
                isLoading && <Loader />
            }
        </div>
    )
}

export default ManageAdmins